import type {Mapper} from 'framework';
import type {ImageBucketImage} from '@/shared/ui/blocks/image-bucket';
import type {AssistantAttachment} from '../../domain/assistant-attachment';

/** The shared `Prompt` block's view of a photo this conversation already uploaded. */
export class AssistantAttachmentToImageBucketImageMapper implements Mapper<
  AssistantAttachment,
  ImageBucketImage
> {
  transform(attachment: AssistantAttachment): ImageBucketImage {
    return {
      id: attachment.id,
      imageUrl: attachment.imageUrl,
      thumbnailUrl: attachment.thumbnailUrl,
      mimeType: attachment.mimeType,
      byteSize: attachment.byteSize,
    };
  }
}
